export default __webpack_public_path__ + "static/media/BusinessReporting.7514489d.png";